import invariant from 'invariant';
import { match } from 'ts-pattern';
import { GameComputedState } from '../GameModel';
import { Phase } from '../Phases';
import { getTutorialData } from '../Tutorial';
import EasyBot from './EasyBot';

export default class TutorialBot extends EasyBot {
  override computeBid(game_state: GameComputedState, user_id: string) {
    const tutorialData = getTutorialData(game_state.age, game_state.turn);
    const botPlanningAction = tutorialData?.botPlanningAction;
    if (botPlanningAction) {
      invariant(
        botPlanningAction.phase === Phase.PLANNING,
        'Bot planning action in tutorial data must have phase PLANNING',
      );
      const tradeRowIndex = match(botPlanningAction.cardSelection)
        .with({ type: 'trade_row_card' }, ({ defID }) => {
          return game_state.table.findIndex((card) => card.defID === defID);
        })
        .with({ type: 'basic_card' }, ({ defID }) => {
          invariant(
            false,
            'Basic cards not allowed in bot planning action in tutorial data',
          );
          return -1;
        })
        .exhaustive();
      invariant(
        tradeRowIndex !== -1,
        `Card with defID ${botPlanningAction.cardSelection.defID} not found on trade row`,
      );
      return {
        military: botPlanningAction?.militaryBid ?? 0,
        tradeRowIndex,
      };
    }
    return super.computeBid(game_state, user_id);
  }

  override computeResolutionSelection(
    game_state: GameComputedState,
    user_id: string,
  ) {
    const tutorialData = getTutorialData(game_state.age, game_state.turn);
    const botResolutionAction = tutorialData?.botResolutionAction;
    if (botResolutionAction) {
      invariant(
        botResolutionAction.phase === Phase.RESOLUTION,
        'Bot resolution action in tutorial data must have phase RESOLUTION',
      );
      let cardIDToGain = '';
      // if (botResolutionAction.cardSelection.type === 'tradeRowIndex') {
      //   cardIDToGain =
      //     game_state.table[botResolutionAction.cardSelection.tradeRowIndex].id;
      // } else
      match(botResolutionAction.cardSelection)
        .with({ type: 'trade_row_card' }, ({ defID }) => {
          const card = game_state.table.find((card) => card.defID === defID);
          invariant(card, `Card with defID ${defID} not found`);
          cardIDToGain = card.id;
        })
        .with({ type: 'basic_card' }, ({ defID }) => {
          const card = game_state.basicPile.find(
            (card) => card.defID === defID,
          );
          invariant(card, `Card with defID ${defID} not found`);
          cardIDToGain = card.id;
        })
        .exhaustive();

      return {
        cardIDToGain,
      };
    }
    return super.computeResolutionSelection(game_state, user_id);
  }
}
